import { Link } from "react-router-dom";

import { Checkbox } from "@/components/ui/checkbox";
import { PRIVACY_PATH, TERMS_PATH } from "@/components/legal/legal-links";

/**
 * The consent checkbox registration requires (issue #40). The server is what
 * decides — `registerWithEmail` refuses without `acceptsTerms`, and the Google
 * button only creates an account when it carries `terms=1` — so this is the
 * half that lets somebody tick it.
 *
 * The links open in a new tab: following one mid-registration and coming back
 * with the browser's back button would empty the form.
 */
export function TermsConsent({
  checked,
  onChange,
  id = "terms-consent",
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
  id?: string;
}) {
  return (
    <div className="flex items-start gap-2.5">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(value) => onChange(value === true)}
        className="mt-0.5"
      />
      <label htmlFor={id} className="text-sm leading-snug">
        Sutinku su{" "}
        <Link to={TERMS_PATH} target="_blank" className="underline underline-offset-4">
          taisyklėmis
        </Link>{" "}
        ir{" "}
        <Link to={PRIVACY_PATH} target="_blank" className="underline underline-offset-4">
          privatumo politika
        </Link>
        .
      </label>
    </div>
  );
}
